import React, { useState } from 'react';
import { getLabel } from '../../InitData';
import SocialButtons from './SocialButtons';

function SocialShareButtons(props) {
    const [copyLinkText, setCopyLinkText] = useState(null);
    const ticketUrl = props.ticketUrl;

    function handleCopyLink() {
    	const android = window.android;
    	if (android && typeof android.writeTextClipboard === "function" ) {
			android.writeTextClipboard(ticketUrl);
            setCopyLinkText(getLabel('checkbet.link_copied'));
            setTimeout(() => setCopyLinkText(null), 1000);
		} else {
    		navigator.clipboard.writeText(ticketUrl).then(() => {
    			setCopyLinkText(getLabel('checkbet.link_copied'));
    			setTimeout(() => setCopyLinkText(null), 1000);
    		});    		
    	}
    }

    return (
        <>
	        <div id="checkbet-share-buttons-container">
                <SocialButtons message={getLabel('checkbet.share_ticket')} ticketUrl={ticketUrl} />
                <div className="checkbet-button ml-auto mr-auto" onClick={handleCopyLink}>
                    {copyLinkText ?
                        copyLinkText
                        :
                        <>
                            {getLabel('checkbet.copy_link')}
                            <i className="fa fa-copy ml-2"></i>
                        </>
                    }
                </div>
	        </div>   
        </>
    )
}

export default SocialShareButtons;